import { getGuideRoleLabel, listGuidePhases, toggleNumericId } from '../../app/helpers/specialistGuideFilterHelper';
import { getGuideModuleTone } from '../../app/helpers/specialistGuideColorHelper';
import { GuideColorDot, SpecialistGuideColorLegend } from './SpecialistGuideColorBadges';

const SpecialistGuideListFilters = ({
  t,
  roles = [],
  modules = [],
  filterRoleId,
  filterPhase,
  filterModuleIds = [],
  showRoleFilter = true,
  visibleCount = 0,
  onRoleChange,
  onPhaseChange,
  onModulesChange,
  onClear
}) => (
  <div className="card mb-4">
    <div className="card-body py-3">
      <div className="row g-3 align-items-end">
        {showRoleFilter ? (
          <div className="col-md-3">
            <label className="form-label" htmlFor="specialist-guide-filter-role">
              {t('specialistGuides.fields.roles')}
            </label>
            <select
              id="specialist-guide-filter-role"
              className="form-select"
              value={filterRoleId || ''}
              onChange={(event) => onRoleChange(event.target.value)}
            >
              <option value="">{t('specialistGuides.filters.allRoles')}</option>
              {roles.map((role) => (
                <option key={role.id || role.catalogrole_id} value={role.id || role.catalogrole_id}>
                  {getGuideRoleLabel(role, t)}
                </option>
              ))}
            </select>
          </div>
        ) : null}

        <div className="col-md-3">
          <label className="form-label" htmlFor="specialist-guide-filter-phase">
            {t('specialistGuides.fields.phase')}
          </label>
          <select
            id="specialist-guide-filter-phase"
            className="form-select"
            value={filterPhase || ''}
            onChange={(event) => onPhaseChange(event.target.value)}
          >
            <option value="">{t('specialistGuides.filters.allPhases')}</option>
            {listGuidePhases().map((phase) => (
              <option key={phase.value} value={phase.value}>
                {phase.label}
              </option>
            ))}
          </select>
        </div>

        <div className="col">
          <label className="form-label d-block">{t('specialistGuides.fields.modules')}</label>
          <div className="d-flex flex-wrap gap-3">
            {modules.map((moduleItem) => {
              const moduleId = Number(moduleItem.id);
              const tone = getGuideModuleTone(moduleItem);
              return (
                <div className="form-check" key={moduleId}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={`specialist-guide-filter-mod-${moduleId}`}
                    checked={filterModuleIds.includes(moduleId)}
                    onChange={() => onModulesChange(toggleNumericId(filterModuleIds, moduleId))}
                  />
                  <label className="form-check-label" htmlFor={`specialist-guide-filter-mod-${moduleId}`}>
                    <GuideColorDot tone={tone} />
                    {moduleItem.name}
                  </label>
                </div>
              );
            })}
          </div>
        </div>

        <div className="col-auto">
          <button type="button" className="btn btn-outline-secondary" onClick={onClear}>
            {t('buttons.clear')}
          </button>
        </div>
      </div>

      <div className="d-flex flex-wrap align-items-start justify-content-between gap-3 mt-3 pt-3 border-top">
        <SpecialistGuideColorLegend t={t} roles={roles} modules={modules} />
        <strong className="sg-count">
          {t('specialistGuides.documentsVisible', { count: visibleCount })}
        </strong>
      </div>
    </div>
  </div>
);

export default SpecialistGuideListFilters;
